var loadNextPage = function(){
  if ($('#next_link').data("loading")){ return }  // prevent multiple loading
  var wBottom  = $(window).scrollTop() + $(window).height();
  var elBottom = $('#storage-info-listing').offset().top + $('#storage-info-listing').height();
};

window.addEventListener('load', loadNextPage);
